<template lang="pug">
    header
        a.main-site(href="http://www.masathena.com/" target="_blank")
            img(src="../assets/images/misc/main-site.svg")
            
        .container
            .left-side
                router-link.logo(to="/")
                    img(src="../assets/images/logo/brand-logo.png")
                h3 Reservations

            .right-side(v-if="total") 
                p SUB TOTAL
                
                .net-total-area
                    p.net-total(v-if="subTotal == 0") USD 0
                    p.net-total(v-if="subTotal > 0") USD {{ subTotal | twoDecimal | decimalSeparator }}
                    //- select(v-model="currency")
                    //-     option(value="USD") USD
                    //-     option(value="LKR") LKR

            
</template>

<script>
    import Vue from 'vue';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'Header',
        data() {
            return {
                currency: 'USD',
                total: true,
                participation: 0,
                accommodation: 0,
                meal: 0,
                activity: 0,
                subTotal: 0
            }
        },
        computed: mapGetters(['getTotal', 'getCurrency', 'currencyDetails']),
        methods: {
            ...mapActions(['changeCurrency', 'getRates']),
            onCurrency() {
                this.currency = this.getCurrency;
            },
            ...Vue.filter('twoDecimal', function(value) {
                if(value) {
                    return Math.round(parseFloat(value) * 100) / 100;
                } else {
                    return 0;
                }
            }),
            ...Vue.filter('decimalSeparator', function(value) {
                if(value) {
                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
            }),            
            updateFee() {
                this.subTotal = this.getTotal;
            },
            onCurrencyUpdate() {
                if(this.getCurrency == 'LKR') {
                    this.getRates().then(() => {

                        this.currency = this.getCurrency;

                        this.subTotal = this.getTotal * this.currencyDetails.lkr;
                    });
                } else {
                   this.updateFee() 
                }
            },            
        },
        created() {
            this.onCurrency();
            this.onCurrencyUpdate();
        },
        mounted() {
            this.onCurrencyUpdate();
        },
        watch:  {
            $route (to) {
                if((to.path == '/result') || (to.path == '/event-result')) {
                    this.total = false;
                } else {
                    this.total = true;
                }
            },
            getTotal: {
                handler: function() {
                    this.onCurrencyUpdate();                    
                }
            },
            currency: {
                handler: function(value) {
                    this.changeCurrency(value).then(() => {
                        this.onCurrencyUpdate();                        
                    });
                }
            }
        }
    };
</script>


<style lang="sass">
    @import "@/assets/css/2-base/_variables.sass"
    @import "@/assets/css/2-base/_placeholder.sass"
    @import "@/assets/css/3-components/_header.sass"
</style>



